// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3YKko","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3bCH8","obliqueLine":"membershipbadge_obliqueLine__DLj41"};